<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div style="display: flex;justify-content: end;">
          <div style="margin-top: 6px; display: flex;margin-right: 25px;">
            <div style="margin-right: 10px;">是否显示该部门教师: </div>
            <div><el-switch @change="handleSwitch" :disabled="true" v-model="isDisplay" active-text="是"
                inactive-text="否"></el-switch></div>
          </div>
          <el-button size="small" class="btn" icon="el-icon-plus" type="primary"
            @click="handleAddAuditing">成员添加</el-button>
          <el-button size="small" @click="handleRoleManagement">角色管理</el-button>
        </div>
      </div>

      <div style="display: flex;">

        <div style="width: 20%;height: 75vh;">
          <div style="width: 90%;  margin-top: 12px;margin-left: 10px; margin-bottom: 10px;">
            <el-input placeholder="搜索部门" v-model="departmentInput" @input="handleInput" clearable> <i slot="prefix"
                class="el-input__icon el-icon-search"></i></el-input>
          </div>
          <div style="width: 100%; height: 1px; border-bottom: 1px solid #ebeef5;  margin-top: 6px;"></div>
          <div style="height:83.3%;overflow-y: auto;">
            <div v-if="dataTree.length > 0">
              <el-tree :data="dataTree" node-key="id" default-expand-all  :props="defaultProps"
                :allow-drop="allowDrop" :allow-drag="allowDrag" @node-drop="handleDrop"
                @node-drag-enter="handleDragEnter" @node-click="handleClickTree">
                <!--
                            @node-drag-start="handleDragStart"
                            @node-drag-enter="handleDragEnter"
                            @node-drag-leave="handleDragLeave"
                            @node-drag-over="handleDragOver"
                            @node-drag-end="handleDragEnd" -->

                <div class="custom-tree-node box" slot-scope="{ node, data }" style="display: flex;">
                  <!-- <span style="flex:1">{{ node.label }}（{{ data.nmu ? data.nmu : 0 }}）</span> -->
                  <div style="flex:1">{{ node.label }}</div>
                  <div style="padding-right:10px;  position: absolute;right: 0;">
                    <!-- <el-popover placement="right"   width="80" trigger="click" style="position: absolute;right: 12px;z-index: 1;"> -->
                      <div>
                        <!-- <div style="margin-bottom: 10px;padding:10px;" class="add"
                          @click="handleTreeClick('添加部门', node, data)">
                          <span class="el-icon-plus" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>添加子部门</span>
                        </div>
                        <div style="margin-bottom: 10px;padding:10px;" class="add"
                          @click="handleTreeClick('编辑部门', node, data)">
                          <span class="el-icon-edit" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>修改部门名</span>
                        </div>
                        <div class="add" style="padding:10px;" @click="handleTreeClick('删除部门', node, data)"
                          v-if="data.deptName !== '蒙正课堂'">
                          <span class="el-icon-delete" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>删除部门</span>
                        </div> -->
                      </div>
                      <span slot="reference" @click="handleTreeClickItme(node, data)">...</span>
                    <!-- </el-popover> -->


                    <!-- <el-dialog :visible="showItme" width="50%" style="z-index: 9999;"  :before-close="handleCloseshowItme" modal-append-to-body	append-to-body>
                      <div>
                        <div style="margin-bottom: 10px;padding:10px;" class="add"  @click="handleTreeClick('添加部门', node, data)">
                          <span class="el-icon-plus" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>添加子部门</span>
                        </div>
                        <div style="margin-bottom: 10px;padding:10px;" class="add"  @click="handleTreeClick('编辑部门', node, data)">
                          <span class="el-icon-edit" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>修改部门名</span>
                        </div>
                        <div class="add" style="padding:10px;" @click="handleTreeClick('删除部门', node, data)"   v-if="data.deptName !== '蒙正课堂'">
                          <span class="el-icon-delete" style="margin-right: 3px; margin-left: 7px;"></span>
                          <span>删除部门</span>
                        </div>
                      </div>
                    </el-dialog> -->


                  </div>
                </div>

              </el-tree>
            </div>
            <div v-else>
              <el-empty description="暂无"></el-empty>
            </div>

          </div>


          <div style="">
            <el-button style="width: 100%; height: 45px;" size="small" @click="handleResignationClick">已离职员工</el-button>
          </div>

        </div>

        <div style="width: 80%;height:75vh; border-left: 1px solid rgba(0,0,0,.15);">

          <div style=" margin-top: 10px; margin-left: 10px; display: flex; margin-bottom: 10px;"
            v-if="!ShowResignationView">
            <div style="margin-top: 6px;margin-right: 6px; margin-left: 10px;width: 140px;">老师姓名:</div>
            <div>
              <el-input v-model="TeacherName" placeholder="请输入内容老师姓名" clearable></el-input>
            </div>
            <div style="margin-top: 6px;margin-right: 6px;margin-left: 5px; margin-left: 15px;width: 140px;">联系电话:</div>
            <div>
              <el-input v-model="TeacherPhone" placeholder="请输入联系电话" clearable></el-input>
            </div>
            <div style="margin-top: 6px;margin-right: 6px;margin-left: 5px; margin-left: 15px;width: 100px;">科目:</div>
            <div>
              <el-select placeholder="请选择科目" v-model="input5" style="width: 100%" clearable multiple filterable>
                <el-option v-for="item in optionList4" :key="item.id" :value="item.id"
                  :label="item.categoryName"></el-option>
              </el-select>
            </div>

            <div style="margin-top: 6px;margin-right: 6px;margin-left: 5px; margin-left: 15px;width: 140px;">所在地域:</div>
            <div>
              <el-select v-model="input6" clearable filterable placeholder="请选择所在地域"  style="width: 100%;" >
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </div>

            <!-- <div style="margin-top: 6px;margin-right: 6px;margin-left: 5px; margin-left: 15px;width: 100px;">地域:</div>
            <div>
              <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" >
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </div> -->
            <div style="margin-left: 40px;width: 50%;display: flex; justify-content: end; padding-right: 7px;">
                <el-button type="primary" size="small" @click="handQuery('取消')">清 空</el-button>
                <el-button type="primary" size="small" @click="handQuery('查询')">查 询</el-button>
                <el-button type="primary" size="small" @click="handQuery('导出')">导 出</el-button>
              </div>

            </div>

          <div style=" margin-top: 10px; margin-left: 10px; display: flex; margin-bottom: 10px;" v-else>
            <div style="margin-top: 6px;margin-right: 6px; margin-left: 10px;width: 100px;">离职日期:</div>
            <div>
              <el-date-picker style="width: 100%;" v-model="dateTimeList" type="daterange" value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable> </el-date-picker>
            </div>
            <div style="margin-top: 6px;margin-right: 6px;margin-left: 5px; margin-left: 15px;width: 100px;">姓名:</div>
            <div style="width: 260px;">
              <el-input v-model="resignationName" style="width: 100%" placeholder="请输入离职人" clearable></el-input>
              <!-- <el-select placeholder="请选择离职人" v-model="resignationName" style="width: 100%"  clearable  filterable>
                            <el-option  v-for="item in getStudentsArr_s"  :key="item.id"  :value="item.id"  :label="item.realname"  > </el-option>
                        </el-select> -->
            </div>
            <div style="margin-left: 40px;width: 50%;display: flex; justify-content: end; padding-right: 7px;">
              <el-button type="primary" size="small" @click="handQuery_s('取消')">清 空</el-button>
              <el-button type="primary" size="small" @click="handQuery_s('查询')">查 询</el-button>
            </div>
          </div>

          <el-table v-if="!ShowResignationView" :data="tableData" height="750" stripe style="width: 100%;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
            <el-table-column prop="regionName" show-overflow-tooltip label="所属地域"></el-table-column>
            <el-table-column prop="realname" show-overflow-tooltip label="姓名" width="180">
              <template slot-scope="scope">
                <span style="color:#4992df;" @click="handleClickName(scope.row)">{{ scope.row.realname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sex" show-overflow-tooltip label="性别">
              <template slot-scope="scope">
                <span>  {{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : ''}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column> -->
            <el-table-column prop="telephone" show-overflow-tooltip label="手机号"></el-table-column>
            <el-table-column prop="teachName" show-overflow-tooltip label="所带学科"></el-table-column>
            <el-table-column prop="deptName" show-overflow-tooltip label="部门">
              <template slot-scope="scope">
                <span style="color:#4992df;" @click="handleClickDep(scope.row)">{{ scope.row.deptName }}</span>
                <span class="el-icon-edit" style="color:#4992df;" @click="handleClickDep(scope.row)"></span>
              </template>
            </el-table-column>
            <el-table-column prop="poName" show-overflow-tooltip label="角色"></el-table-column>
            <el-table-column prop="entryTime" show-overflow-tooltip label="报道日期">
              <template slot-scope="scope">
                <span>{{ scope.row.entryTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="formalTrainingDate" show-overflow-tooltip label="培训日期"></el-table-column>
            <el-table-column prop="noteUrl" show-overflow-tooltip label="简历">
              <template slot-scope="scope">
                <span style="color:#4992df;" @click="handleClickDep(scope.row, '简历')">{{ scope.row.noteUrlName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button class="btn" style="color:#fff;" @click="handleClickOperation(scope.row, '1')"
                  size="small">详情</el-button>
                <el-button @click="handleClickOperation(scope.row, '2')" size="small">授权</el-button>
                <el-button @click="handleClickOperation(scope.row, '3')" size="small">离职交接</el-button>
                <!-- <el-popover placement="top-start" width="50" ref="popover" trigger="hover"
                  style="position: absolute;right: 12px;">
                  <div @click="handleClickOperation(scope.row, '3')" style="padding:10px;" class="add">
                    <span class="el-icon-plus" style="margin-right: 3px; margin-left: 7px;"></span>
                    <span>离职交接</span>
                  </div>
                  <el-button slot="reference" size="small">...</el-button>
                </el-popover> -->
              </template>
            </el-table-column>
          </el-table>


          <el-table v-else :data="tableData_s" height="750" stripe style="width: 100%;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
            <el-table-column prop="realname" label="姓名">
              <template slot-scope="scope">
                <span style="color:#4992df;" @click="handleClickName(scope.row)">{{ scope.row.realname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sex" show-overflow-tooltip label="性别">
              <template slot-scope="scope">
                <span>  {{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : ''}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄"></el-table-column>
            <el-table-column prop="telephone" label="手机号"></el-table-column>
            <el-table-column prop="deptName" label="部门"></el-table-column>
            <!-- <el-table-column  prop="teach" label="所带学科"></el-table-column> -->
            <el-table-column prop="teachName" label="所带学科"></el-table-column>
            <el-table-column prop="poName" label="角色"></el-table-column>
            <el-table-column prop="leaveTime" label="离职日期"></el-table-column>
            <el-table-column prop="leaveCause" label="离职原因"></el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button class="btn" style="color:#fff;" @click="handleClickOperation(scope.row, '1')"
                  size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>


          <el-pagination v-if="!ShowResignationView" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page.sync="pageNo" :page-size="pageSize" :total="total"
            layout="prev, pager, next,sizes,jumper">
          </el-pagination>

          <el-pagination v-else @size-change="handleSizeChange_s" @current-change="handleCurrentChange_s"
            :current-page.sync="pageNo_s" :page-size="pageSize_s" :total="total_s"
            layout="prev, pager, next,sizes,jumper">
          </el-pagination>


        </div>

      </div>

    </el-card>



    <el-dialog :visible="showItme" width="50%" :before-close="handleCloseshowItme" modal-append-to-body	append-to-body>
      <div>

        <div style="margin-bottom: 10px;padding:10px;" @click="handleTreeClick('添加部门', itmeNode, itmeData)">
          <span class="el-icon-plus" style="margin-right: 3px; margin-left: 7px;"></span>
          <span>添加子部门</span>
        </div>
        
        <div style="margin-bottom: 10px;padding:10px;" @click="handleTreeClick('编辑部门', itmeNode, itmeData)">
          <span class="el-icon-edit" style="margin-right: 3px; margin-left: 7px;"></span>
          <span>修改部门名</span>
        </div>

        <div  style="padding:10px;" v-if="itmeData.deptName !== '蒙正课堂'" @click="handleTreeClick('删除部门', itmeNode, itmeData)">
          <span class="el-icon-delete" style="margin-right: 3px; margin-left: 7px;"></span>
          <span>删除部门</span>
        </div>

      </div>
    </el-dialog>


    <el-drawer title="员工详情" :before-close="handleCloseDrawerCler" :visible="dialogDrawer" direction="rtl"
      custom-class="demo-drawer" ref="drawer" close-on-press-escape size="40%">
      <div class="demo-drawer__content">

        <div  style=" font-weight: 900; font-size: 18px;background: rgb(225 225 225); padding: 15px 20px; margin-bottom: 21px;">基础信息</div>
        <el-form :model="form" :disabled="showEdit == false">
          <el-form-item label="姓名:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.realname" type="text" show-word-limit
              maxlength="10"></el-input>
          </el-form-item>

          <el-form-item label="性别:" label-width="160px">
            <el-select style="width: 100%" filterable   v-model="form.sex" autocomplete="off" placeholder="请选择性别" clearable>
              <el-option v-for="jobStatu in jobss" :key="jobStatu.jobId" :label="jobStatu.jobName" :value="jobStatu.jobId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="年龄:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.age" type="text" show-word-limit maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="职级:" label-width="160px">
            <!-- <el-select style="width: 100%" filterable v-model="form.jobtitle" autocomplete="off" placeholder="请选择职级"
              clearable>
              <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                :value="jobStatu.jobId"></el-option>
            </el-select> -->


            <el-cascader clearable style="width: 100%;" v-model="rankId" :options="cascaderoptionsList1" :props="cascaderprops"></el-cascader>

          </el-form-item>

          <el-form-item label="管理职级:" label-width="160px">
            <el-select style="width: 100%" filterable   v-model="rankManageId" autocomplete="off" placeholder="请选择管理职级" clearable>
              <el-option v-for="jobStatu in cascaderoptionsList" :key="jobStatu.id" :label="jobStatu.manageName" :value="jobStatu.id"></el-option>
            </el-select>
          </el-form-item>


          <!-- <el-form-item label="薪资方案:" label-width="160px">
            <el-select v-model="form.salaryPlanId" style="width: 100%" multiple filterable allow-create
              default-first-option placeholder="请选择薪资方案">
              <el-option v-for="(item, index) in planlist" :key="item.id" :label="item.planName" :value="item.id">
                <template #default>
                  <div style="display: flex;justify-content: space-between;" v-if="item.planName">
                    <div style="margin-right: 40px;width: 40%;">{{ item.planName }} </div>
                    <div style="margin-right: 40px;width: 35%;"
                      v-if="item.salaryPlanStartTime || item.salaryPlanEndTime"> {{ item.salaryPlanStartTime }} - {{
                        item.salaryPlanEndTime }} </div>
                    <div style="margin-right: 35px;width: 20%;" @click.stop="handleFieldItemClick(item, '选择有效期', index)">
                      选择有效期</div>
                    <div style="margin-right: 20px;width: 10%;" @click.stop="handleFieldItemClick(item, '编辑')">编辑</div>
                    <div style="width: 10%;" @click.stop="handleFieldItemClick(item, '详情')">详情</div>
                  </div>
                  <div style="display: flex;justify-content: flex-end;" v-if="item.if == '新增'">
                    <div style="padding-left: 20px;color: #21aeef;" @click.stop="handleFieldItemClick(item, '新增')">新增
                    </div>
                  </div>
                </template>
              </el-option>
            </el-select>
          </el-form-item> -->



          <el-form-item label="在职状态:" label-width="160px">
            <el-select style="width: 100%" filterable v-model="form.jobStatus" autocomplete="off" placeholder="请选择在职状态"
              clearable>
              <el-option v-for="item in names" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学科:" label-width="160px">
            <!-- <el-input style="width: 100%;" v-model="form.teach" type="text" show-word-limit maxlength="10"></el-input> -->
            <el-select placeholder="请选择学科" v-model="form.teach" multiple style="width: 100%" clearable filterable>
              <el-option v-for="item in subjectArr_s" :key="item.id" :value="item.id" :label="item.categoryName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电话:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.telephone" type="text" show-word-limit
              maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.email" type="text" show-word-limit maxlength="50"></el-input>
          </el-form-item>
          <!--  <el-form-item label="入职时间:" label-width="160px">
                        <el-date-picker style="width: 100%;" v-model="form.entryTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                    </el-form-item> -->
          <el-form-item label="学历:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.education" type="text" show-word-limit
              maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="毕业院校:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.graduationSchool" type="text" show-word-limit
              maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="身份证号:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.cardId" type="text" show-word-limit maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="周一上课意愿:" label-width="160px">
            <el-select style="width:100%;" filterable v-model="form.monStatus" clearable>
              <el-option v-for="item in workSchedule" :key="item.value" :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一周能接受排课数量:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.weekNum" type="text" show-word-limit
              maxlength="1000"></el-input>
          </el-form-item>
          <el-form-item label="周六课节数不超过:" label-width="160px">
            <el-select v-model="form.satNum" filterable style="width:98%;" clearable>
              <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="周日课节数不超过:" label-width="160px">
            <el-select v-model="form.sunNum" filterable style="width:98%;" clearable>
              <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家庭地址:" label-width="160px">
            <el-input style="width: 100%;" v-model="form.address" type="text" show-word-limit maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="招聘渠道:" label-width="160px">
            <el-radio v-model="form.recruitmentChannel" label="BOSS直聘">BOSS直聘</el-radio>
            <el-radio v-model="form.recruitmentChannel" label="内推">内推</el-radio>
          </el-form-item>
          <el-form-item label="Boss直聘来源负责人:" label-width="160px" v-if="form.recruitmentChannel === 'BOSS直聘'">
            <el-input style="width: 100%;" v-model="form.bossName" type="text" show-word-limit
              maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="内推人:" label-width="160px" v-if="form.recruitmentChannel === '内推'">
            <el-input style="width: 100%;" v-model="form.name" type="text" show-word-limit maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="所在地域:" label-width="160px">
            <el-select v-model="form.regionName" clearable filterable placeholder="请选择所在地域"  style="width: 100%;" >
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报道日期:" label-width="160px">
            <el-date-picker style="width: 100%;" v-model="reportTime" type="date" value-format="yyyy-MM-dd" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="转正日期:" label-width="160px">
            <el-date-picker style="width: 100%;" v-model="estimatedDate" type="date" value-format="yyyy-MM-dd"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="培训日期:" label-width="160px">
            <el-date-picker style="width: 100%;" v-model="formalTrainingDate" type="date" value-format="yyyy-MM-dd"
              clearable> </el-date-picker>
          </el-form-item>
          <el-form-item label="简历:" label-width="160px" @click.native="handleClickDep(noteUrl, '简历')">
            <div
              style="line-height: 28px;color: #00b6ff;text-overflow: ellipsis; overflow: hidden;  white-space: nowrap; width: 100%; height: 30px; border-radius: 4px;  border: 1px solid #e6e6e6;background: #f7f7f7;">
              {{ noteUrl.name }}</div>
          </el-form-item>

          <el-form-item label="证书附件:" label-width="160px" @click.native="handleClickDep1(noteUrls, '证书附件')">
            <div  v-if="showEdit"
              style="line-height: 28px;color: #00b6ff;text-overflow: ellipsis;
              overflow: hidden;  white-space: nowrap; width: 100%; height: 30px;
              border-radius: 4px;  border: 1px solid #e6e6e6;background: #47abe7;"
              >
              <span style="color:#fff;">证书附件</span>
            </div>
          </el-form-item>

        </el-form>

        <div
          style=" font-weight: 900; font-size: 18px;background: rgb(225 225 225); padding: 15px 20px; margin-bottom: 21px;margin-top: 15px;">
          扩展信息</div>

        <el-form style="margin-bottom: 50px;" :model="formExtend" :disabled="!showEdit">
          <el-form-item label="社保:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.socialInsurance" type="text"
              show-word-limit maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item label="参保城市:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.sanhojo" type="text"
              show-word-limit maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item label="社保账号:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.socialSecurityAccount"
              type="text" show-word-limit maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item label="公积金账号:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.cpfAccount" type="text"
              show-word-limit maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item label="银行卡号:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.bankCardNum" type="text"
              show-word-limit maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item label="开户行:" label-width="160px">
            <el-input :disabled="form.isShow" style="width: 100%;" v-model="formExtend.bank" type="text" show-word-limit
              maxlength="50" clearable></el-input>
          </el-form-item>
        </el-form>


        <div class="demo-drawer__footer" style="position: fixed; bottom: 10px; right: 20px;">
          <el-button type="primary" size="small" @click="showEdit = true" v-if="showEdit == false">编 辑</el-button>
          <el-button size="small" @click="handleCloseDrawer" v-if="showEdit == true">取 消</el-button>
          <el-button size="small" type="primary" @click="handleSubmit" v-if="showEdit == true">确 定</el-button>
        </div>

      </div>
    </el-drawer>



    <el-dialog :title="dialogVisibleAddDepTitle" :visible="dialogVisibleAddDep" width="30%"
      :before-close="handleCloseAddDep">
      <el-divider></el-divider>
      <div style="display: flex;">
        <div style="width: 90px;padding-top: 5px;">部门名称：</div>
        <el-input style="width: 100%;" v-model="depName" clearable></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseAddDep">取 消</el-button>
        <el-button size="small" type="primary" @click="handleCloseAddDepSub">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog :title="'成员【' + dialogVisibleMemberTitle + '】'" :visible="dialogVisibleMember" width="30%"
      :before-close="handleCloseMember">
      <el-divider></el-divider>
      <div style="display: flex;">
        <div style="width: 90px;padding-top: 5px;">所属部门：</div>
        <el-select v-model="belongingDepName" popper-class="tree-select-popper">
          <el-option hidden :value="belongingDepName"> </el-option>
          <el-tree :data="dataTrees" :props="defaultPropss" node-key="deptId" ref="belongingTree"
            :highlight-current="true" :check-on-click-node="true" @check="handleTreeCheck">
          </el-tree>
        </el-select>
      </div>

      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button size="small" @click="handleCloseMember">取 消</el-button>
          <el-button size="small" type="primary" @click="handleCloseMemberSub">确 定</el-button>
        </span>
      </template>
    </el-dialog>


    <el-dialog :title="dialogRoleManagementTitle" :visible="dialogRoleManagementVisible" width="60%"
      :before-close="handleCloseRoleManagemen">
      <el-divider></el-divider>
      <div style="display: flex; height: 65vh;">
        <div style="width: 50%;border: 1px solid #ebeef5;">
          <div
            style="text-align: start;height: 36px;border-bottom: 1px solid rgb(235, 238, 245);padding-top: 20px;padding-left: 12px;">
            角色列表</div>
          <div style="overflow-y: auto;height: 95%;">
            <el-table v-show="dialogRoleManagementTitle !== '设置员工角色'" @row-click="handleRowClick"
              :highlight-current-row="true" :data="roleTableData" ref="roleTableData" height="500" style="width: 100%;"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }">
              <el-table-column prop="poName" label="角色"></el-table-column>
              <el-table-column prop="poRemarks" label="描述" width="150"></el-table-column>
              <!-- <el-table-column  label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="handleRole(scope.row,'1')" size="small">编辑</el-button>
                                </template>
                            </el-table-column> -->
            </el-table>

            <el-table v-show="dialogRoleManagementTitle === '设置员工角色'" @row-click="handleRowClick"
              :highlight-current-row="true" :data="roleTableData" ref="roleTableData" height="500" style="width: 100%;"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }">
              <el-table-column type="radio" width="55">
                <template slot-scope="scope">
                  <el-radio v-model="SelectionrRadio" :label="scope.row.poId"
                    @change="handleSelectionChange(scope.row)">&nbsp;</el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="poName" label="角色"></el-table-column>
              <el-table-column prop="poRemarks" label="描述" width="150"></el-table-column>
            </el-table>

            <el-button v-if="dialogRoleManagementTitle !== '设置员工角色'" style="padding-top: 14px;" type="text"
              class="el-icon-plus" @click="handleRole('', '3')" size="small">添加角色</el-button>
          </div>
        </div>
        <div style="width: 50%;border: 1px solid #ebeef5;">
          <div
            style="text-align: start;height: 36px;border-bottom: 1px solid rgb(235, 238, 245);padding-top: 20px;padding-left: 12px;">
            权限管理</div>
          <div style="overflow-y: auto;height: 90%;">
            <el-tree :class="dialogRoleManagementTitle === '设置员工角色' ? 'no_click' : ''" :data="dataAuthorityList"
              ref="TreeInit" show-checkbox node-key="jurId" default-expand-all :props="defaultProps_s"></el-tree>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseRoleManagemen">取 消</el-button>
        <el-button size="small" v-if="dialogRoleManagementTitle !== '设置员工角色'" type="primary"
          @click="handleCloseRoleManagemenSub">确 定</el-button>
        <el-button size="small" v-if="dialogRoleManagementTitle === '设置员工角色'" type="primary"
          @click="handleCloseRoleManagemenSub_s">确 定</el-button>
      </span>

    </el-dialog>



    <el-dialog :title="RoleShowTltie" :visible="RoleShow" width="40%" :before-close="handleRoleShowTltieClose">
      <el-divider></el-divider>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="width: 90px;padding-top: 5px;">角色名称：</div>
        <el-input style="width: 100%;" v-model="roleName" type="text" maxlength="10" show-word-limit
          clearable></el-input>
      </div>
      <div style="display: flex;margin-bottom: 20px;">
        <div style="width: 90px;padding-top: 5px;">角色描述：</div>
        <el-input style="width: 100%;" v-model="roleDescribe" type="textarea" maxlength="200" show-word-limit
          :autosize="{ minRows: 6, maxRows: 6 }"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleRoleShowTltieClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleRoleShowTltieCloseSub">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="导出设置" :visible="addBtnShow"  :before-close="handleRoleShowTltieCloseaddBtnShow">

      <div style="display: flex;">
        <div style="padding-top: 10px;">时间范围：</div>
        <div>
          <el-date-picker v-model="rangeTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>

      <div style="display: flex;margin-top: 20px;">
        <div style="padding-top: 10px;">导出类型：</div>
        <div>
          <el-select v-model="rangevalue" placeholder="请选择">
            <el-option v-for="item in rangeoptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="addCommitBtn">开始导出</el-button>
      </div>

    </el-dialog>



    <el-dialog :title="addMembersShowTitle" :visible="addMembersShow" :before-close="handleAddMembersShowClose"
      width="70%">
      <addMembers v-if="addMembersShow" ref="addMembersNodes" @handleEventNodes="handleEventNodes"></addMembers>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleAddMembersShowClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleAddMembersShowSubt">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="离职交接" :visible="resignationTime" :before-close="handleresignationTimeClose" width="50%">
      <div style="display: flex;width: 100%;margin-bottom: 20px;">
        <div style="margin-top: 5px; margin-right: 10px;width: 100px;">离职时间:</div>
        <div style="width: 100%">
          <el-date-picker value-format="yyyy-MM-dd" v-model="resignationTimeValue" type="date"  placeholder="选择离职日期" style="width: 100%"></el-date-picker>
        </div>
      </div>
      <div style="display: flex;width: 100%">
        <div style="margin-top: 5px; margin-right: 10px;width: 100px;">离职原因:</div>
        <div style="width: 100%">
          <el-input style="width: 100%;" type="textarea"  :autosize="{ minRows: 10, maxRows: 10 }" maxlength="999999" show-word-limit  v-model="leaveCause"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleresignationTimeClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleresignationTimeSubt">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="预览简历" width="50%" style="padding: 0px 50px;" :visible="showInfo"
      :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
      <Guciya v-if="showInfo" :url="urls"></Guciya>
    </el-dialog>

    <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible="showInfos"
      :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
      <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下
        载</el-button>
      <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
    </el-dialog>

    <GuciSalarPlan v-if="shoiwGuci" @handleEvent="handleEvent" :type="type" :currentRow="currentRow"></GuciSalarPlan>


    <el-dialog title="选择有效期" append-to-body :visible="dialogVisible" width="60%" :close-on-click-modal="false"
      :before-close="dialogVisibleCle">
      <div style="display: flex;margin-bottom: 20px;">
        <div style="margin-right: 10px;">方案名称：</div>
        <div>{{ rowitme.planName }}</div>
      </div>
      <div style="display: flex;">
        <div style="padding-top: 10px; margin-right: 10px;">有效期：</div>
        <div>
          <el-date-picker style="width: 100%;" v-model="dateTimeList" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable>
          </el-date-picker>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCle">取消</el-button>
        <el-button type="primary" @click="dialogVisibleCleSave">保存</el-button>
      </span>
    </el-dialog>



    <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible="showImgDing"
      :before-close="showImgDingClers5" :close-on-click-modal="false">
      <div style="margin-bottom: 20px;">
        <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下
          载</el-button>
      </div>
      <div>
        <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
      </div>
    </el-dialog>


    <Elupload v-if="isShowElupload" @handleEventElUpload="handleEventElUpload" @handleEventElUploadSubt="handleEventElUploadSubt" :Uploadtypes="Uploadtypes" :fileAllLists="fileAllLists"></Elupload>


  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import addMembers from './addMembers.vue'
import { getSubject, } from "@/api/firstClassApi";
import Guciya from "../InterviewManagement/components/Guciya-compoents";
import GuciSalarPlan from './Guci-SalarPlan'
import Elupload from "./Elupload";


export default {
  components: { addMembers, Guciya, GuciSalarPlan, Elupload },
  data() {
    return {

      input6:'',

      showImgDing: false,
      showImgDingurlsss: '',

      noteUrls:[],

      editorOptions: {
        toolbar: true,
        width: '800px',
        height: '600px'
      },
      showInfos: false,
      docxContent: '',

      leaveCause: '',
      showInfo: false,
      urls: '',

      addMembersShow: false,
      addMembersShowTitle: '添加成员',

      showEdit: false,
      departmentInput: '',
      dataTree: [],
      defaultProps: { children: 'children', label: 'deptName' },

      defaultPropss: { children: 'children', label: 'deptName' },
      dataTrees: [],

      tableData: [],

      roleTableData: [],
      subjectArr_s: [],
      dialogDrawer: false,
      form: {
        id: '',
        sex:'',
        email: '',
        teach: [],
        realname: '',
        telephone: '',
        age: '',
        jobStatus: '',
        jobtitle: '',

        entryTime: '',
        introducerName: '',
        recruitmentChannel: '',
        graduationSchool: '',
        education: '',
        cardId: '',
        weekNum: 0,
        bossName: '',
        radio: '',
        monStatus: '',
        satNum: '',
        sunNum: '',
        address: '',
        salaryPlanId: [],
        name: '',
        jobName: '',
        regionName: '',
      },

      rankManageId: '',
      rankId: '',

      formExtend: {
        socialInsurance: '',
        sanhojo: '',
        socialSecurityAccount: '',
        cpfAccount: '',
        bankCardNum: '',
        bank: '',
      },

      dialogVisibleAddDep: false,
      dialogVisibleAddDepTitle: '',

      depName: '',

      dialogVisibleMemberTitle: '',
      dialogVisibleMember: false,
      belongingDepName: '',


      dialogRoleManagementVisible: false,
      dialogRoleManagementTitle: '',

      RoleShowTltie: '',
      RoleShow: false,

      roleName: '',
      roleDescribe: '',


      dataAuthorityList: [],
      dataAuthorityListKeys: [],
      defaultProps_s: { children: 'children', label: 'jurTitle', },


      parentNode: null,
      depNameID: '',

      ParentLevelD: '',
      SonNodeID: '',

      isID: '',
      isDisplay: false,


      cascaderprops: { checkStrictly: true, value: 'id', label: 'salaryPlanName', children: 'teacherRankList' },
      cascaderoptionsList: [],
      cascaderoptionsList1: [],

      jobss: [{ jobId: 1, jobName: "男"},{ jobId: 2,jobName: "女"}],

      TeacherName: '',
      TeacherPhone: '',

      addBtnShow: false,
      rangeTime: [],
      rangevalue: '',
      rangeoptions: [{ id: 1, name: '跟进学员' }],


      resignationTime: false,
      resignationTimeValue: '',
      resignationTeacherID: '',

      ShowResignationView: false,
      dateTimeList: [],
      resignationName: '',
      pageNo: 1,
      pageSize: 10,
      total: 10,

      pageNo_s: 1,
      pageSize_s: 10,
      total_s: 10,

      updateDeptdeptId: '',
      updateDeptteacherId: '',


      names: [{ value: 1, label: "在职" }, { value: 2, label: "离职" }],
      jobs: [],
      planlist: [],
      workSchedule: [{ value: "接受排课", id: 1, }, { value: "不接受排课", id: 2, }],
      workWeekend: [{ value: "服从安排", id: 1, }, { value: "不排课", id: 2, }, { value: "排一节", id: 3, }, { value: "排二节", id: 4, }, { value: "排三节", id: 5, }, { value: "排四节", id: 6, }, { value: "排五节", id: 7, }, { value: "排六节", id: 8, }],

      tableData_s: [],

      po_id: 0,
      user_id: 0,

      SelectionrRadio: '',
      isIDS: '',


      optionList4: [],
      input5: [],

      regionName:1,

      reportTime: '',
      estimatedDate: '',
      formalTrainingDate: '',
      noteUrl: { name: '', url: '' },


      rowitme: {},
      rowindex: 0,
      type: '',
      showDetails: false,
      shoiwGuci: false,
      dialogVisible: false,
      dateTimeList: [],

      currentRow: null,

      optionsListt:[],

      isShowElupload: false,
      fileAllLists:[],
      Uploadtypes:'',


      itmeNode:'',
      itmeData:'',

      showItme: false,

    }
  },

  created() {
    axios.post(`${apiBaseUrl}/admin/jurisdictionlist`, { po_id: 0, jur_title: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
      let data = response.data.data.list
      for (let i = 0; i < data.length; i++) {
        if (data[i].jurTitle == "小程序权限") {
          this.dataAuthorityList.push(JSON.parse(JSON.stringify(data[i])))
        } else {
          this.dataAuthorityList.push(JSON.parse(JSON.stringify(data[i])))
        }
      }
    })


     axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },

  mounted() {
    this.handleGetqueryCreator()
    this.handlegetOrgTree()

    axios.get(`${apiBaseUrl}/teacher/query/job`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => { this.jobs = res.data.data.list })
    //  axios.get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {this.planlist = res.data.data})

    axios.get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
        this.planlist = res.data.data
    }).catch(error => { })

    axios.get(`${apiBaseUrl}/organizational/getOrgTree`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.dataTrees = res.data.data })
    axios.post(`${apiBaseUrl}/admin/postlist`, { po_id: '0', poName: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => { this.roleTableData = response.data.data.list })
    getSubject().then((res) => { this.subjectArr_s = res.data; this.optionList4 = res.data })


    axios.get(`${apiBaseUrl}/teacherRankManage/findList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
      this.cascaderoptionsList = res.data.data
    }).catch(error => { })


    axios.post(`${apiBaseUrl}/teacherRank/findList`, {},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code == 200) {
            this.cascaderoptionsList1 = res.data.data
         }else {
            this.$message.error(res.data.message);
            this.cascaderoptionsList1 =  []
          }
    }).catch(err => {
          this.cascaderoptionsList1 =  []
    });


  },

  methods: {

    handleTreeClickItme(node,data){
      this.showItme = true
      this.itmeNode = node
      this.itmeData = data
    },


    handleCloseshowItme(){
      this.showItme = false
      this.itmeNode = ''
      this.itmeData = ''
    },

    handleEventElUploadSubt(flileList){
        this.isShowElupload = false
        if(flileList && flileList.length > 0){
            this.fileAllLists = flileList
        }else{
          this.fileAllLists = []
        }
    },


    handleEventElUpload(flileList){
        this.isShowElupload = false
    },

    showImgDingClers5() {
      this.showImgDing = false
      this.showImgDingurlsss = ''
    },

    handleDownload1() {
      let ele = document.createElement('a')
      ele.setAttribute('href', this.showImgDingurlsss)
      document.body.appendChild(ele)
      ele.click()
    },

    dialogVisibleCleSave() {
      this.planlist[this.rowindex].salaryPlanStartTime = this.dateTimeList[0]
      this.planlist[this.rowindex].salaryPlanEndTime = this.dateTimeList[1]
      this.dialogVisible = false
      this.dateTimeList = []
    },

    dialogVisibleCle() {
      this.dateTimeList = []
      this.dialogVisible = false
    },

    handleEvent(e) {
      this.shoiwGuci = e
    },

    dialogVisibleDetailsCle() {
      this.showDetails = false
    },

    handleFieldItemClick(itme, type, index) {
      console.log(itme, type, index, 'handleFieldItemClick')

      if (type === '选择有效期') {
        this.rowindex = index
        this.rowitme = itme
        if (itme.salaryPlanStartTime) {
          // this.dateTimeList[0] = itme.salaryPlanStartTime
          this.$set(this.dateTimeList, 0, itme.salaryPlanStartTime)
        }
        if (itme.salaryPlanEndTime) {
          this.$set(this.dateTimeList, 1, itme.salaryPlanEndTime)
          // this.dateTimeList[1] = itme.salaryPlanEndTime
        }

        this.dialogVisible = true
      }
      if (type === '编辑') {
        this.type = '编辑'
        this.currentRow = itme
        this.shoiwGuci = true
      }
      if (type === '详情') {
        this.type = '详情'
        this.currentRow = itme
        this.shoiwGuci = true
      }
      if (type === '新增') {
        this.type = '新增'
        this.currentRow = null
        this.shoiwGuci = true
      }
    },

    handleDownload() {
      let ele = document.createElement('a')
      ele.setAttribute('href', this.docxContent)
      document.body.appendChild(ele)
      ele.click()
    },

    showshowInfoViewInfoCler() {
      this.showInfo = false
    },

    showshowInfoViewInfoClers() {
      this.showInfos = false
    },

    handleSelectionChange(e) {
      console.log(e, 'handleSelectionChange')
    },

    handleResignationClick() {
      this.ShowResignationView = true
      let data = {
        startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '',
        realname: this.resignationName,
        pageNo: this.pageNo_s ? this.pageNo_s : 1,
        pageSize: this.pageSize_s ? this.pageSize_s : 10,
      }
      axios.post(`${apiBaseUrl}/teacher/getLeaveStaffList`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: '查询成功' })
          let data = res.data.data
          this.pageNo_s = data.pageIndex
          this.total_s = data.allTotal
          this.tableData_s = data.list

          console.log(data, 'res=========>>>>')
        } else {
          this.$message({ type: 'error', message: '查询成功' })
        }
      })
    },

    handleresignationTimeClose() {
      this.resignationTime = false
      this.resignationTimeValue = ''
      this.leaveCause = ''
    },

    handleresignationTimeSubt() {
      this.handleTeacherUpdate()
    },

    handleGetqueryCreator() {
      axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }, }).then(res => {
        this.getStudentsArr_s = res.data.data
      })
    },

    handleTeacherUpdate() {
      if(this.leaveCause){
        let data = {
          id: this.resignationTeacherID,
          leaveTime: this.resignationTimeValue,
          leaveCause: this.leaveCause,
          jobStatus: 2,
        }
        axios.post(`${apiBaseUrl}/teacher/updateLeaveStaff`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if (res.data.code == 200) {
            this.$message({ type: 'success', message: res.data.message })
            this.handlegetOrgTree()
            this.resignationTime = false
            this.resignationTimeValue = ''
            this.leaveCause = ''
          } else {
            this.$message({ type: 'error', message: res.data.message })
          }
        })
      }else{
        this.$message({ type: 'warning', message: '请填写离职原因~' })
      }
    },


    handleRoleShowTltieCloseaddBtnShow(){
      this.addBtnShow = false
      this.rangeTime = []
      this.rangevalue = ""

    },

    handleOrganizational() {
      let data = {
        deptName: this.depName,
        //    parentId: this.parentNode.parent.data.deptId,
        parentId: this.parentNode.data.deptId,
        orderNo: 1,
      }
      axios.post(`${apiBaseUrl}/organizational/create`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgTree()
          this.depName = ''
          this.dialogVisibleAddDep = false
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handlegetOrgTree() {
      axios.get(`${apiBaseUrl}/organizational/getOrgTree`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        let data = res.data.data
        this.dataTree = data
        this.isDisplay = this.dataTree[0].isDisplay == 1 ? true : false
        this.isIDS = this.dataTree[0].id
        this.handlegetOrgStaffs()
      })
    },

    handleUpdate() {
      let data = {
        deptName: this.depName,
        id: this.depNameID,
      }
      axios.post(`${apiBaseUrl}/organizational/update`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgTree()
          this.depName = ''
          this.dialogVisibleAddDep = false
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handleGetTeaInfo(id) {

      axios.get(`${apiBaseUrl}/organizational/getTeaInfo/${id}`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data
          if (data) {

            this.form.sex =  data.sex ? data.sex : ''

            this.form.id = data.id
            this.form.email = data.email
            this.form.realname = data.realname
            this.form.telephone = data.telephone
            this.form.age = data.age
            this.form.jobStatus = data.jobStatus
            this.form.jobtitle = data.jobtitle


            this.rankId = data.rankId
            this.rankManageId = data.rankManageId


            this.form.introducerName = data.introducerName
            this.form.name = this.form.introducerName

            this.form.recruitmentChannel = data.recruitmentChannel
            this.form.graduationSchool = data.graduationSchool
            this.form.weekNum = data.weekNum
            this.form.education = data.education
            this.form.cardId = data.cardId
            this.form.bossName = data.bossName
            this.form.radio = data.radio
            this.form.monStatus = data.monStatus
            this.form.satNum = data.satNum
            this.form.sunNum = data.sunNum
            this.form.address = data.address
            // this.form.name = data.name
            this.form.regionName = data.regionName === '北京' ? 1 : data.regionName === '深圳' ? 2 : data.regionName === '上海' ? 3 : data.regionName


            this.form.jobName = data.jobName

            if (data.teach) {
              this.form.teach = JSON.parse(data.teach)

            }

            if (data.entryTime) {
              this.reportTime = data.entryTime
            }

            this.estimatedDate = data.estimatedDate

            this.formalTrainingDate = data.formalTrainingDate

            if (data.noteUrl) {
              this.noteUrl = JSON.parse(data.noteUrl)
            }

            if (data.certificateAnnex) {
              this.noteUrls = JSON.parse(data.certificateAnnex)
            }

            console.log(this.form.teach, 'this.form.teach')
          }

          if (data.extendStr) {
            this.formExtend = data.extendStr
          }

          if (data.teacherSalaryMiddleList && data.teacherSalaryMiddleList.length > 0) {
            let ids = []
            data.teacherSalaryMiddleList.map((itme)=>{
              if(itme.salaryPlanId){
                ids.push(itme.salaryPlanId)
              }
            })
            this.form.salaryPlanId = ids
          } else {
            this.form.salaryPlanId = []
          }

          console.log(res.data.data, 'res.data===============>>>>>>>>>查询信息')

        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handleMove() {
      let data = {
        parentId: this.ParentLevelD,
        deptId: this.SonNodeID,
        orderNo: 1,
      }
      axios.put(`${apiBaseUrl}/organizational/move`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgTree()
          this.ParentLevelD = ''
          this.SonNodeID = ''
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },


    handleDelete(id) {
      axios.delete(`${apiBaseUrl}/organizational/delete?id=${id}`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgTree()
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },


    handlegetIsDisplay(id, isDisplay) {
      axios.get(`${apiBaseUrl}/organizational/isDisplay?id=${id}&isDisplay=${isDisplay}`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgTree()
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handleDeptOrTeaUpdateDept() {
      // let data = { deptId: this.updateDeptdeptId,  teacherId: this.updateDeptteacherId, }
      axios.put(`${apiBaseUrl}/deptOrTea/updateDept?deptId=${this.updateDeptdeptId}&teacherId=${this.updateDeptteacherId}`, {}, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          this.dialogVisibleMember = false
          let data = {
            deptId: this.isID ? this.isID : this.dataTree[0].deptId,
            telephone: this.TeacherPhone ? this.TeacherPhone : '',
            realname: this.TeacherName ? this.TeacherName : '',
            pageNo: this.pageNo ? this.pageNo : 1,
            pageSize: this.pageSize ? this.pageSize : 10,
            categoryIdList: this.input5.length > 0 ? this.input5 : [],
            regionName: this.input6 ? this.input6 : window.localStorage.getItem('cityTepy')
          }
          axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
            if (res.data.code == 200) {
              let data = res.data.data
              this.pageNo = data.pageIndex
              this.total = data.allTotal
              this.tableData = data.list
              this.tableData.forEach(element => {
                if (element.noteUrl) {
                  element.noteUrlName = JSON.parse(element.noteUrl).name
                } else {
                  element.noteUrlName = ''
                }
              });

            } else {
              this.$message({ type: 'error', message: res.data.message })
            }
          })

        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handleSwitch(e) {
      let Nub = e ? 1 : 0
      // this.handlegetIsDisplay(this.isID, Nub)
      this.handlegetIsDisplay(this.isIDS, Nub)
    },


    handleClickTree(data) {
      this.isDisplay = data.isDisplay == 1 ? true : false
      this.isID = data.deptId
      this.isIDS = data.id
      this.handlegetOrgStaffs()
      this.ShowResignationView = false
    },


    handlegetOrgStaffs() {
      let data = {
        deptId: this.isID ? this.isID : this.dataTree[0].deptId,
        telephone: this.TeacherPhone ? this.TeacherPhone : '',
        realname: this.TeacherName ? this.TeacherName : '',
        pageNo: this.pageNo ? this.pageNo : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryIdList: this.input5.length > 0 ? this.input5 : [],
        regionName: this.input6 ? this.input6 : window.localStorage.getItem('cityTepy')
      }
      axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          let data = res.data.data
          this.pageNo = data.pageIndex
          this.total = data.allTotal
          this.tableData = data.list
          this.tableData.forEach(element => {
            if (element.noteUrl) {
              element.noteUrlName = JSON.parse(element.noteUrl).name
            } else {
              element.noteUrlName = ''
            }
          });
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },

    handQuery(type) {
      if (type === '取消') {
        this.TeacherName = ''
        this.TeacherPhone = ''
        this.input6 = ''
        this.input5 = []
        this.regionName = 1
        this.handlegetOrgStaffs()
      }
      if (type === '查询') {
        this.handlegetOrgStaffs()
      }
      if (type === '导出') {
        this.addBtnShow = true
      }
    },

    handQuery_s(type) {
      this.handleGetqueryCreator()
      if (type === '取消') {
        this.dateTimeList = []
        this.resignationName = ''
        let data = {
          startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '',
          realname: this.resignationName,
          pageNo: this.pageNo_s ? this.pageNo_s : 1,
          pageSize: this.pageSize_s ? this.pageSize_s : 10,
        }
        axios.post(`${apiBaseUrl}/teacher/getLeaveStaffList`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if (res.data.code == 200) {
            this.$message({ type: 'success', message: '查询成功' })
            let data = res.data.data
            this.pageNo_s = data.pageIndex
            this.total_s = data.allTotal
            this.tableData_s = data.list
            console.log(res.data, 'res=========>>>>')
          } else {
            this.$message({ type: 'error', message: res.data.message })
          }
        })
      }
      if (type === '查询') {
        let data = {
          startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '',
          endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '',
          realname: this.resignationName,
          pageNo: this.pageNo_s ? this.pageNo_s : 1,
          pageSize: this.pageSize_s ? this.pageSize_s : 10,
        }
        axios.post(`${apiBaseUrl}/teacher/getLeaveStaffList`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if (res.data.code == 200) {
            this.$message({ type: 'success', message: '查询成功' })
            let data = res.data.data
            this.pageNo_s = data.pageIndex
            this.total_s = data.allTotal
            this.tableData_s = data.list
            console.log(res.data, 'res=========>>>>')
          } else {
            this.$message({ type: 'error', message: res.data.message })
          }
        })
      }
    },



    addCommitBtn() {
      loadingUtils.startLoading()
      let data = {
        exportType: this.rangevalue,
        startTime: `${this.rangeTime[0] ? this.rangeTime[0] : ''}`,
        endTime: `${this.rangeTime[1] ? this.rangeTime[1] : ''}`,
      }
      axios.post(`${apiBaseUrl}/teacher/exportTeaType`, data, { responseType: "blob", headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if (response.status == 200) {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "跟进学员.xlsx";
          downloadLink.click();
          loadingUtils.endLoading()
          this.$message({ message: "导出成功", type: "success" });
          this.rangevalue = ''
          this.rangeTime = []
          this.addBtnShow = false
        }
        else {
          this.$message.error("导出失败");
        }
      })
    },


    handleCurrentChange(current) {
      this.pageNo = current
      let data = {
        deptId: this.isID ? this.isID : this.dataTree[0].deptId,
        telephone: this.TeacherPhone ? this.TeacherPhone : '',
        realname: this.TeacherName ? this.TeacherName : '',
        pageNo: this.pageNo ? this.pageNo : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryIdList: this.input5.length > 0 ? this.input5 : [],
        regionName: this.input6 ? this.input6 : window.localStorage.getItem('cityTepy')
      }
      axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          let data = res.data.data
          this.pageNo = data.pageIndex
          this.total = data.allTotal
          this.tableData = data.list
          this.tableData.forEach(element => {
            if (element.noteUrl) {
              element.noteUrlName = JSON.parse(element.noteUrl).name
            } else {
              element.noteUrlName = ''
            }
          });


        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      let data = {
        deptId: this.isID ? this.isID : this.dataTree[0].deptId,
        telephone: this.TeacherPhone ? this.TeacherPhone : '',
        realname: this.TeacherName ? this.TeacherName : '',
        pageNo: this.pageNo ? this.pageNo : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryIdList: this.input5.length > 0 ? this.input5 : [],
        regionName: this.input6 ? this.input6 : window.localStorage.getItem('cityTepy')
        // regionName: this.regionName ? this.regionName : '',
      }
      axios.post(`${apiBaseUrl}/organizational/getOrgStaffs`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: res.data.message })
          let data = res.data.data
          this.pageNo = data.pageIndex
          this.total = data.allTotal
          this.tableData = data.list
          this.tableData.forEach(element => {
            if (element.noteUrl) {
              element.noteUrlName = JSON.parse(element.noteUrl).name
            } else {
              element.noteUrlName = ''
            }
          });
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })

    },
    handleCurrentChange_s(current) {
      this.pageNo_s = current
      let data = {
        startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '',
        realname: this.resignationName,
        pageNo: this.pageNo_s ? this.pageNo_s : 1,
        pageSize: this.pageSize_s ? this.pageSize_s : 10,
      }
      axios.post(`${apiBaseUrl}/teacher/getLeaveStaffList`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: '查询成功' })
          let data = res.data.data
          this.pageNo_s = data.pageIndex
          this.total_s = data.allTotal
          this.tableData_s = data.list
          console.log(res.data, 'res=========>>>>')
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })

    },
    handleSizeChange_s(size) {
      this.pageSize_s = size
      let data = {
        startTime: this.dateTimeList.length > 0 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList.length > 0 ? this.dateTimeList[1] : '',
        realname: this.resignationName,
        pageNo: this.pageNo_s ? this.pageNo_s : 1,
        pageSize: this.pageSize_s ? this.pageSize_s : 10,
      }
      axios.post(`${apiBaseUrl}/teacher/getLeaveStaffList`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200) {
          this.$message({ type: 'success', message: '查询成功' })
          let data = res.data.data
          this.pageNo_s = data.pageIndex
          this.total_s = data.allTotal
          this.tableData_s = data.list
          console.log(res.data, 'res=========>>>>')
        } else {
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },


    handleTreeCheck(e) {
      this.belongingDepName = e.deptName
      this.updateDeptdeptId = e.deptId
    },

    // handleDragStart(node, ev) {
    //     let {}  = node
    //     console.log( node);
    // },

    handleDragEnter(draggingNode, dropNode, ev) {
      let { data } = dropNode
      console.log(draggingNode, dropNode, 'handleDragEnter');
      this.ParentLevelD = data.deptId
    },

    // handleDragLeave(draggingNode, dropNode, ev) {
    //     console.log('333333333333333 ', draggingNode, dropNode);
    // },

    // handleDragOver(draggingNode, dropNode, ev) {
    //     console.log('444444444444 ', draggingNode, dropNode);
    // },

    // handleDragEnd(draggingNode, dropNode, dropType, ev) {
    //     console.log('555555555555555 ', draggingNode, dropNode, dropType);
    // },

    handleDrop(draggingNode, dropNode, dropType, ev) {
      let { parent, data } = draggingNode
      console.log(draggingNode, dropNode, 'handleDrop');
      this.SonNodeID = data.deptId
      this.handleMove()
    },

    allowDrop(draggingNode, dropNode, type) {
      return dropNode.data.deptName !== '蒙正课堂';
    },

    allowDrag(draggingNode) {
      return draggingNode.data.deptName !== '蒙正课堂';
    },

    handleClickName(itme) {
      this.handleGetTeaInfo(itme.id)
      this.showEdit = false
      this.dialogDrawer = true
    },

    handleClickOperation(itme, type) {

      console.log('11111111111111111111111111')

      if (type === '1') {
        this.handleGetTeaInfo(itme.id)

        axios.get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList/${itme.id ? itme.id : 0}`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          this.planlist = res.data.data
          this.planlist.push({ if: '新增' })
        })

        this.showEdit = false
        this.dialogDrawer = true
      }
      if (type === '2') {
        this.dialogRoleManagementTitle = '设置员工角色'
        //  this.user_id = itme.id
        this.user_id = itme.adminId

        axios.post(`${apiBaseUrl}/admin/postlist`, { user_id: this.user_id, poName: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
          let poid = response.data.data.list[0].poId
          axios.post(`${apiBaseUrl}/admin/postlist`, { po_id: '0', poName: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => { this.roleTableData = response.data.data.list })
          this.$nextTick(() => {
            if (this.user_id) {
              this.SelectionrRadio = poid
              this.dialogRoleManagementVisible = true
            } else {
              const h = this.$createElement;
              this.$notify({ title: '提示信息', message: h('i', { style: 'color: red' }, '该教师无账号信息,无法进行授权~ ') })
            }
          })

        })

      }
      if (type === '3') {
        this.resignationTime = true
        this.resignationTeacherID = itme.id
        // if(this.$refs.popover){
        //   this.$refs.popover.doClose()
        // }
      }
    },

    handleCloseRoleManagemen() {
      this.dataAuthorityListKeys = []
      this.dialogRoleManagementVisible = false
    },

    handleCloseRoleManagemenSub() {
      let allCheckedNodes = this.$refs.TreeInit.getCheckedNodes(false, true)
      let idList = allCheckedNodes.map(node => node.jurId);
      let idStr = idList.join(",")
      axios.post(`${apiBaseUrl}/admin/postaddjur`, { "po_id": this.po_id, "jur_id": idStr }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if (response.data.code === 200) {
          this.$message({ type: 'success', message: '操作成功', })
          this.dataAuthorityListKeys = []
          this.dialogRoleManagementVisible = false
          this.handlegetOrgStaffs()
        }
        else {
          this.$message({ type: 'error', message: '操作失败', })
        }
      })
    },

    handleCloseRoleManagemenSub_s() {
      axios.post(`${apiBaseUrl}/admin/useraddpost`, { user_id: this.user_id, po_id: this.po_id }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if (response.data.code === 200) {
          this.$message({ message: '角色设置成功', type: 'success' })
          this.handlegetOrgStaffs()
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },

    handleAddAuditing() {
      this.addMembersShow = true
      this.addMembersShowTitle = '添加成员'
    },

    handleAddMembersShowSubt() {
      this.$refs.addMembersNodes.handleSubmit()
    },

    handleEventNodes(event) {

      this.handlegetOrgStaffs()
      this.addMembersShow = event
    },

    handleAddMembersShowClose() {
      this.addMembersShow = false
    },

    handleRoleManagement() {
      axios.post(`${apiBaseUrl}/admin/postlist`, { po_id: '0', poName: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => { this.roleTableData = response.data.data.list })
      this.dialogRoleManagementTitle = '角色管理'
      this.dialogRoleManagementVisible = true
    },

    handleCloseDrawerCler() {
      this.dialogDrawer = false
    },

    handleCloseDrawer() {
      // this.formExtend = {
      //   socialInsurance:'',
      //   sanhojo:'',
      //   socialSecurityAccount:'',
      //   cpfAccount:'',
      //   bankCardNum:'',
      //   bank:'',
      // }
      this.showEdit = false
    },

    handleSubmit() {
      this.handleGetTeacherUpdate()
    },

    handleGetTeacherUpdate() {

      let data = this.form
      data.entryTime = this.reportTime
      data.estimatedDate = this.estimatedDate
      data.formalTrainingDate = this.formalTrainingDate
      data.extend = JSON.stringify(this.formExtend)
      data.teach = this.form.teach && this.form.teach.length < 1 ? '[' + this.form.teach + ']' : JSON.stringify(this.form.teach)
      data.introducerName = this.form.name

      let salaryPlanList = []
      this.planlist.map((itme) => {
        this.form.salaryPlanId.map((itmes) => {
          if (itmes === itme.id) {
            salaryPlanList.push({ salaryPlanId: itme.id, salaryPlanStartTime: itme.salaryPlanStartTime ? itme.salaryPlanStartTime : '', salaryPlanEndTime: itme.salaryPlanEndTime ? itme.salaryPlanEndTime : '' })
          }
        })
      })
      // delete data.salaryPlanId
      data.salaryPlanList = salaryPlanList


      if(this.fileAllLists && this.fileAllLists.length > 0){
        data.certificateAnnex = JSON.stringify(this.fileAllLists)
      }else{
        data.certificateAnnex = ''
      }

      data.rankId = this.rankId && this.rankId.length > 0 ? this.rankId[this.rankId.length - 1] : ''
      data.rankManageId = this.rankManageId? this.rankManageId : ''

      axios.post(`${apiBaseUrl}/teacher/update`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.code == 200 || res.data.code == 20001) {
          this.$message({ type: 'success', message: res.data.message })
          this.handlegetOrgStaffs()
          this.showEdit = false
          // this.dialogDrawer = false
          this.form.teach = []
          this.formExtend = {
            socialInsurance: '',
            sanhojo: '',
            socialSecurityAccount: '',
            cpfAccount: '',
            bankCardNum: '',
            bank: '',
          }
          this.form.salaryPlanId = []
          this.fileAllLists = []
        } else {
          this.form.teach = []
          this.form.salaryPlanId = []
          this.$message({ type: 'error', message: res.data.message })
        }
      })
    },


    getFileName(name) {
      return name.substring(name.lastIndexOf("."))
    },

    handleClickDep1(row, type){
      console.log(row, type)
      if(type === '证书附件'){
        this.Uploadtypes = '截图'
        this.fileAllLists = row
        this.isShowElupload = true
      }
    },

    handleClickDep(row, type) {
      console.log(row)

      if (type === '简历') {
        if (row.noteUrl) {
          let { name, url } = JSON.parse(row.noteUrl)
          if (this.getFileName(name) === ".pdf") {
            this.urls = url
            this.showInfo = true
          } else if (this.getFileName(name) === ".docx" || this.getFileName(name) === ".doc") {
            this.docxContent = url
            this.showInfos = true
          } else {
            if (this.getFileName(url) === ".jpg" || this.getFileName(url) === ".png") {
              this.showImgDingurlsss = url
              this.showImgDing = true
            }
            else {
              this.$message({ type: 'warning', message: '请检查是否为有效的简历类型~' })
            }
          }
        }

        if (row.url) {
          if (this.getFileName(row.name) === ".pdf") {
            this.urls = row.url
            this.showInfo = true
          } else if (this.getFileName(row.name) === ".docx" || this.getFileName(row.name) === ".doc") {
            this.docxContent = row.url
            this.showInfos = true
          } else {
            if (this.getFileName(row.name) === ".jpg" || this.getFileName(row.name) === ".png") {
              this.showImgDingurlsss = row.url
              this.showImgDing = true
            }
            else {
              this.$message({ type: 'warning', message: '请检查是否为有效的简历类型~' })
            }
          }
        }


      } else {

        this.dialogVisibleMemberTitle = row.realname
        this.belongingDepName = row.deptName


        this.updateDeptdeptId = row.deptId
        this.updateDeptteacherId = row.id


        axios.get(`${apiBaseUrl}/organizational/getOrgTree`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.dataTrees = res.data.data })


        this.dialogVisibleMember = true
      }
    },


    handleCloseMember() {
      this.dialogVisibleMember = false
    },


    handleCloseMemberSub() {
      this.handleDeptOrTeaUpdateDept()
    },


    handleRowClick(e) {
      this.po_id = e.poId
      let data = { po_id: e.poId }
      axios.post(`${apiBaseUrl}/admin/jurisdictionlisttwo`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        this.dataAuthorityListKeys = response.data.data.list;
        this.$refs.TreeInit.setCheckedKeys(this.dataAuthorityListKeys)
      })
    },

    handleCloseAddDep() {
      console.log('取消')
      this.depName = ''
      this.dialogVisibleAddDep = false
    },

    handleCloseAddDepSub() {

      if (this.dialogVisibleAddDepTitle === '编辑部门') {
        this.handleUpdate()
      } else {
        this.handleOrganizational()
      }
    },

    handleTreeClick(type, node, data) {

      console.log(type, node, data)

      if (type === '添加部门') {
        this.parentNode = node
        this.dialogVisibleAddDepTitle = '添加部门'
        this.dialogVisibleAddDep = true
      }

      if (type === '编辑部门') {
        this.dialogVisibleAddDepTitle = '编辑部门'
        this.depName = data.deptName
        this.depNameID = data.id
        this.dialogVisibleAddDep = true
      }

      if (type === '删除部门') {
        this.$confirm('此操作将删除【教师部】， 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleDelete(data.id)
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
      }

    },


    handleInput(e) {
      axios.get(`${apiBaseUrl}/organizational/getOrgTree?deptName=${e}`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
        if (res.data.data) {
          this.dataTree = res.data.data
        } else {
          this.dataTree = []
        }
      })
    },


    handleRole(itme, type) {
      console.log(itme)
      if (type === '1') {
        this.RoleShowTltie = '编辑'
        this.roleName = itme.name
        this.roleDescribe = itme.phone
        this.RoleShow = true
      }
      if (type === '2') {
        this.$confirm('你确定要删除当前项吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({ type: 'success', message: '删除成功!' })
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
      }
      if (type === '3') {
        this.roleName = ''
        this.roleDescribe = ''
        this.RoleShowTltie = '添加'
        this.RoleShow = true
      }
    },

    handleRoleShowTltieClose() {
      this.roleName = ''
      this.roleDescribe = ''
      this.RoleShow = false
    },

    handleRoleShowTltieCloseSub() {
      if (this.roleName) {
        axios.post(`${apiBaseUrl}/admin/addPost`, { poName: this.roleName, poRemarks: this.roleDescribe }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          if (res.data.code == 200) {
            this.$message({ type: 'success', message: "添加成功" })
            axios.post(`${apiBaseUrl}/admin/postlist`, { po_id: '0', poName: '' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => { this.roleTableData = response.data.data.list })
            this.RoleShow = false
          } else {
            this.$message({ type: 'error', message: "添加失败" })
          }
        })
      } else {
        this.$message({ type: 'warning', message: "角色名称不能为空" })
      }
    },



  },


}
</script>



<style lang="less" scoped>
.btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

/deep/ .el-card__body {
  padding: 0px;
}

/deep/ .el-input__inner {
  height: 30px;
}

/deep/ .el-input__prefix {
  margin-top: -5px;
}


/deep/ .el-tree-node.is-current>.el-tree-node__content {
  color: #1890ff;
  background: #e8f4ff;
}

.add:hover {
  padding: 10px 10px;
  background: #4992df;
  color: #fff;
  border-radius: 5px;
}

/deep/ .el-drawer__header {
  font-weight: 900;
  font-size: 18px;
  background: #f5f7fa;
  padding: 15px 20px;
}

/deep/.el-divider--horizontal {
  margin-top: -26px;
}

/deep/ .el-dialog__header {
  text-align: start;
}

/deep/ .el-drawer__header {
  text-align: start;
}

/deep/ .el-input__suffix-inner {
  display: flex;
  margin-top: -3px;
}

/deep/ .el-range__close-icon {
  position: absolute;
  right: 0px;
}

/deep/ .el-range-separator {
  margin-top: -10px;
}

/deep/ .el-icon-date {
  display: none;
}

.no_click {
  pointer-events: none;
}


</style>



// WEBPACK FOOTER //
// src/teamOrganization/organizationalStructure.vue